const keys = {
  INDEXES: "indexes",
  INDEX: "index",
  VIDEOS: "videos",
  TASK: "task",
  SEARCH: "search",
  AUTHORS: "authors",
};

export default keys;
